import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import { uploadFileAndGetKey } from "../Recruitment/utils/fileUtils"; // Adjust path if needed

const FilePreviewModal = ({
  showModal,
  setShowModal,
  previewUrl,
  setPreviewUrl,
  selectedFile,
  setSelectedFile,
  folderName = "chat_attachments",
  actionLabel = "Send Attachment",
  loadingLabel = "Sending...",
  onUploadSuccess,
}) => {
  const [uploading, setUploading] = useState(false);

  // Helper function to check if the current file/url is a PDF
  const isPdf =
    selectedFile?.type === "application/pdf" ||
    (typeof previewUrl === "string" && previewUrl.split("?")[0].toLowerCase().endsWith(".pdf"));

  const handleSendFile = async () => {
    if (!selectedFile) return;
    setUploading(true);

    try {
      // Upload file and retrieve fileKey
      const fileKey = await uploadFileAndGetKey(selectedFile, folderName);

      // Notify parent component with uploaded key
      if (onUploadSuccess) {
        onUploadSuccess(fileKey);
      }

      // Close modal and reset state
      handleClose();
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Failed to upload file. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setPreviewUrl("");
    setSelectedFile(null);
  };

  return (
    <Modal isOpen={showModal} toggle={handleClose} size="lg" centered>
      <ModalHeader toggle={handleClose}>
        Preview Attachment {selectedFile?.name ? `- ${selectedFile.name}` : ""}
      </ModalHeader>
      
      <ModalBody className="text-center p-3">
        {previewUrl ? (
          isPdf ? (
            <div className="w-100" style={{ height: "500px" }}>
              <iframe
                src={previewUrl}
                title="PDF Preview"
                width="100%"
                height="100%"
                style={{ border: "1px solid #dee2e6", borderRadius: "4px" }}
              />
            </div>
          ) : (
            <img
              src={previewUrl}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "500px",
                objectFit: "contain",
                borderRadius: "4px",
              }}
            />
          )
        ) : (
          <p className="text-muted my-4">No preview available.</p>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={handleClose} disabled={uploading}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSendFile} disabled={uploading || !selectedFile}>
          {uploading ? (
            <>
              <Spinner size="sm" className="me-2" />
              {loadingLabel}
            </>
          ) : (
            actionLabel
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FilePreviewModal;